import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Container,
  Title,
  Text,
  Button,
  Stack,
  Paper,
  List,
} from "@mantine/core";
import { IconArrowLeft } from "@tabler/icons-react";

export default function ContactPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Container size="md" py="xl">
      <Stack gap="xl">
        <Paper p="xl" radius="md" withBorder>
          <Stack gap="lg">
            <Title order={1}>{t("contact.title")}</Title>

            <Stack gap="md">
              <Text size="md">
                Denne madbestillingsapp drives af Martin Shakib, Smagly ("vi",
                "os"). Når du bruger appen, behandler vi nogle personoplysninger
                om dig. Her kan du læse kort, hvad vi gør med dem.
              </Text>

              <Title order={3}>Hvilke oplysninger vi indsamler</Title>
              <Text size="md" mb="xs">
                Afhængigt af hvordan du bruger appen, kan vi indsamle:
              </Text>
              <List size="md" spacing="xs">
                <List.Item>Navn</List.Item>
                <List.Item>E-mailadresse</List.Item>
                <List.Item>Telefonnummer</List.Item>
                <List.Item>
                  Oplysninger om din ordre (hvad du bestiller)
                </List.Item>
                <List.Item>
                  Evt. fritekst-noter til din ordre (f.eks. dørkode, ønsket
                  levering, allergier)
                </List.Item>
                <List.Item>
                  En 6-cifret afhentningskode knyttet til din ordre
                </List.Item>
                <List.Item>
                  Login-oplysninger (e-mail og adgangskode, som gemmes som en
                  sikker hash – ikke i klartekst)
                </List.Item>
              </List>

              <Title order={3}>Hvad vi bruger oplysningerne til</Title>
              <Text size="md" mb="xs">
                Vi bruger dine oplysninger til at:
              </Text>
              <List size="md" spacing="xs">
                <List.Item>Oprette og håndtere din ordre</List.Item>
                <List.Item>
                  Kontakte dig om din ordre, hvis det er nødvendigt
                </List.Item>
                <List.Item>
                  Give dig mulighed for at oprette en konto og logge ind
                </List.Item>
                <List.Item>
                  Forbedre appen og sikre, at den fungerer teknisk
                </List.Item>
              </List>
              <Text size="md" mt="xs">
                Vi sælger ikke dine oplysninger videre.
              </Text>

              <Title order={3}>Hvor længe vi gemmer oplysninger</Title>
              <Text size="md" mb="xs">
                Vi gemmer dine oplysninger, så længe det er nødvendigt for at:
              </Text>
              <List size="md" spacing="xs">
                <List.Item>Kunne vise og håndtere dine ordrer</List.Item>
                <List.Item>
                  Teste og forbedre denne prototype af appen
                </List.Item>
              </List>
              <Text size="md" mt="xs">
                Hvis du ikke længere ønsker, at vi har dine oplysninger, kan du
                altid skrive til os (se kontakt herunder), så sletter vi dem.
              </Text>

              <Title order={3}>Cookies og lokal lagring</Title>
              <Text size="md" mb="xs">
                Vi bruger ikke trackingcookies til marketing. Appen bruger:
              </Text>
              <List size="md" spacing="xs">
                <List.Item>
                  <Text fw={600}>localStorage</Text> i din browser til:
                  <List withPadding size="sm" spacing="xs" mt="xs">
                    <List.Item>At gemme din indkøbskurv</List.Item>
                    <List.Item>
                      At gemme din login-session (token), hvis du er logget ind
                    </List.Item>
                  </List>
                </List.Item>
                <List.Item>
                  En simpel mekanisme til at huske dit valgte sprog (f.eks. via
                  localStorage og/eller en teknisk cookie)
                </List.Item>
              </List>
              <Text size="md" mt="xs">
                Disse ting bruges kun for at få appen til at fungere og gøre
                oplevelsen mere praktisk for dig.
              </Text>

              <Title order={3}>Dine rettigheder</Title>
              <Text size="md" mb="xs">
                Du har ret til at:
              </Text>
              <List size="md" spacing="xs">
                <List.Item>
                  Få at vide, hvilke oplysninger vi har om dig
                </List.Item>
                <List.Item>Få rettet forkerte oplysninger</List.Item>
                <List.Item>
                  Få slettet dine oplysninger ("retten til at blive glemt")
                </List.Item>
                <List.Item>
                  Gøre indsigelse mod vores behandling af dine oplysninger
                </List.Item>
              </List>
              <Text size="md" mt="xs">
                Hvis du vil bruge en af dine rettigheder, kan du kontakte os.
              </Text>

              <Title order={3}>Kontakt</Title>
              <Text size="md">
                Hvis du har spørgsmål til, hvordan vi behandler dine
                oplysninger, eller ønsker at få dem slettet, kan du kontakte:
              </Text>
              <Text size="md" mt="xs">
                <Text fw={600}>Martin Shakib</Text>
                <br />
                <Text component="a" href="mailto:smaglynem@gmail.com" c="blue">
                  smaglynem@gmail.com
                </Text>
              </Text>
            </Stack>
          </Stack>
        </Paper>

        <Button
          leftSection={<IconArrowLeft size={16} />}
          onClick={() => navigate("/")}
          variant="light"
        >
          {t("contact.backToHome")}
        </Button>
      </Stack>
    </Container>
  );
}
